import { useState } from "react";
import '../styles/productcard.css';

function ProductoCard({ producto }) {
  const [modalOpen, setModalOpen] = useState(false);

  const abrirModal = () => setModalOpen(true);
  const cerrarModal = () => setModalOpen(false);

  return (
    <>
      <div className={`product ${producto.categoria}`}>
        <figure>
          <img 
            src={producto.imagen}
            alt={producto.titulo}
            className="product-image" 
            onClick={abrirModal}
            style={{ cursor: 'pointer' }}
          />
        </figure>
        <div className="product-description">
          <div className="info">
            <h1>{producto.titulo}</h1>
            <p>{producto.descripcion}</p>
          </div>
        </div>
      </div>

      {modalOpen && (
        <div 
          className="modal-overlay"
          onClick={cerrarModal}
          style={{
            position: "fixed",
            top: 0, left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            cursor: "pointer",
          }}
        >
          <div 
            style={{ 
              position: 'relative',
              cursor: 'default',
              textAlign: 'center',
              color: 'white'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Botón X para cerrar */}
            <button
              onClick={cerrarModal}
              style={{
                position: 'absolute',
                top: '-30px',
                right: '0',
                background: 'transparent',
                border: 'none',
                color: 'red',
                fontSize: '30px',
                fontWeight: 'bold',
                cursor: 'pointer',
                outline: 'none',
              }}
              aria-label="Cerrar visor de imagen"
            >
              &times;
            </button>

            <img
              src={producto.imagen}
              alt={producto.titulo}
              style={{
                maxWidth: "90vw",
                maxHeight: "80vh",
                borderRadius: "10px",
                display: 'block',
                marginBottom: '15px',
              }}
            />

            {/* Título debajo de la imagen */}
            <h2 style={{ margin: 0, fontSize: '1.5rem' }}>
              {producto.titulo}
            </h2>
          </div>
        </div>
      )}
    </>
  );
}

export default ProductoCard;
